import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import Vuelidate from "vuelidate";
import VueGtag from "vue-gtag";
import * as VueGoogleMaps from "vue2-google-maps";
import VueMask from "v-mask";
import VueRouter from "vue-router";
import vco from "v-click-outside";
import router from "./router/index";
import Scrollspy from "vue2-scrollspy";
import VueSweetalert2 from "vue-sweetalert2";
import vuetify from "@/plugins/vuetify"; // path to vuetify export
import "../src/design/app.scss";
import store from "@/state/store";
import App from "./App.vue";
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import { base } from "@/mixins/base";
import i18n from "./i18n";
import tinymce from "vue-tinymce-editor";
import AOS from "aos";
import Toast from "vue-toastification";
import ToggleButton from "vue-js-toggle-button";
import SplitCarousel from "vue-split-carousel";
import "vue-split-carousel/dist/vue-split-carousel.css";
import "vue-toastification/dist/index.css";
import "aos/dist/aos.css";
const VueScrollTo = require("vue-scrollto");
const options = {
  position: "top-right",
};
Vue.component("tinymce", tinymce);
Vue.use(VueRouter);
Vue.use(vco);
Vue.use(Scrollspy);
Vue.use(ToggleButton);
Vue.use(VueScrollTo);
Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueMask);
Vue.use(require("vue-chartist"));
Vue.use(VueSweetalert2);
Vue.use(Toast, options);
Vue.component("Layout", Layout);
Vue.component("PageHeader", PageHeader);
Vue.use(SplitCarousel);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCGVe7zxBnM9GNZ4EEd-Kz2yqjcadHjwmY",
    libraries: "places",
  },
  installComponents: true,
});
Vue.component("apexchart", VueApexCharts);
Vue.use(
  VueGtag,
  {
    config: {
      id: "G-KM76002030",
      params: {
        send_page_view: false,
      },
    },
    appName: "merchant-portal",
    pageTrackerScreenviewEnabled: true,
  },
  router
);
Vue.filter("currency", (value) => {
  return value + " " + "AED";
});
Vue.mixin(base);
new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: (h) => h(App),
  mounted() {
    AOS.init({
      duration: 1500,
    });
  },
}).$mount("#app");
